<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SMSAbT/media/FC-9798886939880.jpg?1738887697505" alt="This image is the cover for the book Mirrors"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mirrors
      </h1>
      <p class="bookDescription body article font2">
        <p>Mirrors is a collection of three stories that look beyond the surface of what reality appears to be. </p><p><br/></p><p><em><strong>Mirrors</strong></em></p><p><br/></p><p>Katrina has worked the same job in the same small town her entire life. She has always considered herself and her existence nothing but commonplace and boring until a birthday present—one she promised herself never to use—changed everything. </p><p><br/></p><p>Each of us has a different version of ourselves. Some are better when left undiscovered. </p><p><br/></p><p><em><strong>Deciduous</strong></em></p><p><br/></p><p>Daisy wakes up in a hospital bed with vague memories and broken images of her past. Her caretaker explains that she was the sole survivor of a tragic accident that left her parents dead.</p><p><br/></p><p><em>They are all in a room</em>, says a pressing voice that will soon lead her to discover the transience of seasons as they bring about death and form new life.</p><p><br/></p><p><em><strong>What’s On the Menu?</strong></em></p><p><br/></p><p>Chris Newberry has won the most coveted prize that one could win: a trip to <em>What’s On the Menu?</em></p><p><br/></p><p>In a society that relies solely on supplements for sustenance, <em>What’s On the Menu? </em>is the only chance to experience the long-lost sensation of eating. </p><p><br/></p><p>But in order to get there, you have to win the lottery. And if you do win, the trip is one you might never forget. </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sam Allen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7cb6b366